<template>
	<div>
		<!-- MOCK: for Apeiron -->
		<template v-if="['apeiron_uat', 'apeiron'].includes($store.state.tenantId)">
			<apeiron-organizations-detail />
		</template>

		<!-- default internals detail -->
		<template v-else>
			<default-organizations-detail />
		</template>
	</div>
</template>

<script>
import DefaultOrganizationsDetail from "../components/DefaultOrganizationsDetail"
import ApeironOrganizationsDetail from "../components/mockedApeiron/ApeironOrganizationsDetail"

export default {
	components: {
		DefaultOrganizationsDetail,
		ApeironOrganizationsDetail
	}
}
</script>
